import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { loggedInUserData, UserLevelMappingModel } from '@app/modules';
import { AppState } from '@app/reducers';
import { CrudService, CustomDirectiveConfig, formConfigs, getPDropdownData, IApplicationResponse, ModulesBasedApiSuffix, NO_CHANGES_DETECTED_MSG, ResponseMessageTypes, RxjsService, setRequiredValidator, SnackbarService, UserService } from '@app/shared';
import { PrimengCustomDialogComponent } from '@app/shared/components/primeng-custom-dialog';
import { ItManagementApiSuffixModels } from '@modules/others/configuration/utils';
import { UserLogin } from '@modules/others/models';
import { select, Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { forkJoin, Observable } from 'rxjs';
@Component({
  selector: 'app-it-management-user-level-mapping-add-edit',
  templateUrl: './user-level-mapping-add-edit.component.html'
})

export class UserLevelMappingAddEditComponent implements OnInit {
  formConfigs = formConfigs;
  stringConfig = new CustomDirectiveConfig({ isAStringOnly: true, shouldPasteKeyboardEventBeRestricted: true });
  userLevelMappingAddEditForm: FormGroup;
  userLevelMappingForm: FormGroup;
  loggedUser: UserLogin;
  userLevelRoleId: any = ""
  isDuplicate = false;
  addArray: any
  status: any = []
  rolesList = []
  userLevelsList = []
  isAdd = true
  userLevelRoleIdOnCreate = ""
  primengTableConfigProperties: any;
  constructor(
    private crudService: CrudService,
    private router: Router,
    private dialogService: DialogService,
    private userService: UserService,
    private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private snackbarService: SnackbarService,
    private store: Store<AppState>, private rxjsService: RxjsService) {
    this.userLevelRoleId = this.activatedRoute.snapshot.queryParams.id;
    if (this.userLevelRoleId) {
      this.isAdd = false;
    }
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
    let isEditArr: any = [{ displayName: 'Add User Level Mapping' }];
    if (this.userLevelRoleId) {
      isEditArr = [{ displayName: 'View', relativeRouterUrl: '/configuration/it-management/user-level-mapping-view', queryParams: { id: this.userLevelRoleId } }, { displayName: 'Update User Level Mapping' }]
    }
    this.primengTableConfigProperties = {
      tableCaption: `${this.userLevelRoleId ? 'Update' : 'Add'} User Level Mapping`,
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Configuration' }, { displayName: 'IT Management', relativeRouterUrl: '/configuration/it-management' }, { displayName: 'User Level Mapping List', relativeRouterUrl: '/configuration/it-management', queryParams: { tab: 4 } },
      ...isEditArr],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'User Level Mapping',
            dataKey: 'userLevelRoleId',
            enableBreadCrumb: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            enableAddActionBtn: true,
            shouldShowDeleteActionBtn: false,
            shouldShowCreateActionBtn: true,
            areCheckboxesRequired: false,
            isDateWithTimeRequired: true,
            url: '',
          },
        ]
      }
    }
  }

  ngOnInit(): void {
    this.userLevelMappingForm = this.createUserMappingArray()
    this.createUserLevelMappingForm();
    this.getAllDropdown().subscribe((response: IApplicationResponse[]) => {
      this.userLevelsList = getPDropdownData(response[0].resources, 'userLevelName', 'userLevelId');
      this.rolesList = getPDropdownData(response[1].resources, 'roleName', 'roleID');
      this.rxjsService.setGlobalLoaderProperty(false);
      if (this.userLevelRoleId) {
        this.getDetailsById().subscribe((response: IApplicationResponse) => {
          if (response.isSuccess) {
            const addObj: any = {
              userLevelRoleId: response.resources[0]?.userLevelRoleId,
              userId: this.loggedUser?.userId,
              description: response.resources[0]?.description,
              userLevelId: response.resources[0]?.userLevelId,
              roleID: (response.resources[0]?.roleId).toLowerCase().split(','),
              isActive: response.resources[0]?.isActive == true && "Active" || "In-Active",
            }
            this.getuserLevelMappingArray.push(this.createUserMappingArray(addObj));
            this.onChangeUserLevel(0)
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        });
      }
    });
    this.rxjsService.setGlobalLoaderProperty(false);
    this.status = [
      { label: "Active", value: "Active" },
      { label: "In-Active", value: "In-Active" },
    ];
  }

  createUserLevelMappingForm(): void {
    this.userLevelMappingAddEditForm = this.formBuilder.group({});
    this.userLevelMappingAddEditForm.addControl('userLevelMappingArray', this.formBuilder.array([]));
    // if (!this.userLevelRoleId) {
    //   this.getuserLevelMappingArray.push(this.createUserMappingArray());
    // }
  }

  onChangeUserLevel(index?: number) {
    let userLevelId = this.userLevelMappingForm.get("userLevelId").value;
    if (index != null) {
      userLevelId = this.getuserLevelMappingArray.at(index).get("userLevelId").value;
    }
    this.crudService.get(ModulesBasedApiSuffix.CONFIGURE_IT_MANAGEMENT, ItManagementApiSuffixModels.UX_ROLE_USER_LEVEL_MAPPING_WITH_ID, userLevelId).subscribe(response => {
      this.rxjsService.setGlobalLoaderProperty(false);
      if (response.isSuccess && response.statusCode == 200) {
        if (index != null) {
          this.getuserLevelMappingArray.at(index).get("roleID").setValue(response?.resources?.roleID);
          this.getuserLevelMappingArray.at(index).get("userLevelRoleId").setValue(response?.resources?.userLevelRoleId);
        } else {
          this.userLevelMappingForm.get("roleID").setValue(response?.resources?.roleID);
          this.userLevelMappingForm.get("userLevelRoleId").setValue(response?.resources?.userLevelRoleId);
        }
      }
    })
  }

  createUserMappingArray(serviceListModel?: UserLevelMappingModel): FormGroup {
    let servicesModel = new UserLevelMappingModel(serviceListModel);
    let formControls = {};
    Object.keys(servicesModel).forEach((key) => {
      if (key == 'description' || key == "userLevelRoleId") {
        formControls[key] = [{ value: servicesModel[key], disabled: false }, []]
      } else {
        formControls[key] = [{ value: servicesModel[key], disabled: false }, [Validators.required]]
      }
    });
    formControls['userId'] = this.loggedUser?.userId
    return this.formBuilder.group(formControls);
  }

  get getuserLevelMappingArray(): FormArray {
    return this.userLevelMappingAddEditForm?.get('userLevelMappingArray') as FormArray;
  }

  removeUserLevel(i: number): void {
    if (this.getuserLevelMappingArray.length === 1) {
      this.snackbarService.openSnackbar("Atleast one record is required", ResponseMessageTypes.WARNING);
      return;
    }
    else {
      let customText = "Are you sure you want to delete this?"
      const confirm = this.dialogService.open(PrimengCustomDialogComponent, {
        header: 'Confirmation',
        showHeader: false,
        closable: true,
        baseZIndex: 10000,
        width: '400px',
        data: { customText: customText },
      });
      this.userService.openedPrimeDialog.push(confirm);
      confirm.onClose.subscribe((resp) => {
        if (resp === false) {
          this.isDuplicate = false;
          this.getuserLevelMappingArray.removeAt(i);
        }
        this.userService.openedPrimeDialog = [];
      });
    }
  }

  getDetailsById(): Observable<IApplicationResponse> {
    return this.crudService.get(
      ModulesBasedApiSuffix.CONFIGURE_IT_MANAGEMENT,
      ItManagementApiSuffixModels.USER_LEVEL_MAPPING,
      this.userLevelRoleId, true, null, 1
    );
  }

  addUserLevel() {
    if (this.userLevelMappingForm.invalid) {
      return this.userLevelMappingForm.markAllAsTouched();
    }
    this.isDuplicate = false;
    this.getuserLevelMappingArray.push(this.createUserMappingArray(this.userLevelMappingForm.value));
    this.userLevelMappingForm.reset()
    this.userLevelMappingForm.get("isActive").setValue("");
    this.userLevelMappingForm.get("userLevelId").setValue("");
    this.userLevelMappingForm.markAsUntouched();
  }

  getAllDropdown(): Observable<any> {
    return forkJoin(
      this.crudService.get(ModulesBasedApiSuffix.CONFIGURE_IT_MANAGEMENT, ItManagementApiSuffixModels.UX_USER_LEVEL_MAPPING, undefined, true),
      this.crudService.get(ModulesBasedApiSuffix.CONFIGURE_IT_MANAGEMENT, ItManagementApiSuffixModels.UX_ROLE_USER_LEVEL_MAPPING, undefined, true),
    )
  }

  onSubmit() {
    if (this.getuserLevelMappingArray.length === 0) {
      this.snackbarService.openSnackbar('Atleast one record is required', ResponseMessageTypes.WARNING);
      return;
    }
    if (this.userLevelMappingAddEditForm.invalid) {
      return this.userLevelMappingAddEditForm.markAllAsTouched();
    }
    if (!this.userLevelMappingAddEditForm.dirty && this.userLevelRoleId) {
      return this.snackbarService.openSnackbar(NO_CHANGES_DETECTED_MSG, ResponseMessageTypes.WARNING);
    }
    let addArray = [...this.getuserLevelMappingArray.getRawValue()];
    let postObject = {
      userLevelRoleId: this.userLevelRoleId || this.userLevelRoleIdOnCreate,
      userLevelMappings: addArray
    }
    postObject['userLevelMappings'].map((items: any) => {
      items.isActive = items.isActive == "Active" && true || false;
    });
    this.rxjsService.setFormChangeDetectionProperty(true);
    let crudService: Observable<IApplicationResponse> = this.crudService.create(ModulesBasedApiSuffix.CONFIGURE_IT_MANAGEMENT, ItManagementApiSuffixModels.USER_LEVEL_MAPPING, postObject, 1)
    crudService.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess) {
        this.goBack()
      }
    });
  }

  goBack() {
    this.router.navigate(['/configuration/it-management'], { queryParams: { tab: 4 } });
  }
}
